/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edited_Once_Double_CheckInputs */

const en_orders_edited_once_double_check = /** @type {(inputs: Orders_Edited_Once_Double_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edited Once - Double Check`)
};

const es_orders_edited_once_double_check = /** @type {(inputs: Orders_Edited_Once_Double_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editado una vez - revisar`)
};

/**
* | output |
* | --- |
* | "Edited Once - Double Check" |
*
* @param {Orders_Edited_Once_Double_CheckInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edited_once_double_check = /** @type {((inputs?: Orders_Edited_Once_Double_CheckInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edited_Once_Double_CheckInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edited_once_double_check(inputs)
	return es_orders_edited_once_double_check(inputs)
});